/* ===== HomeLabs theme scripts ===== */
(function () {
  'use strict';

  const money = (cents) =>
    (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  /* ---- Cart drawer ---- */
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-toggle]').forEach((el) =>
    el.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); renderCart(); })
  );
  document.querySelectorAll('[data-cart-close]').forEach((el) =>
    el.addEventListener('click', closeDrawer)
  );
  overlay && overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  /* ---- Reassemble obfuscated email links ---- */
  document.querySelectorAll('[data-eml-user][data-eml-domain]').forEach(function (el) {
    var addr = el.getAttribute('data-eml-user') + '@' + el.getAttribute('data-eml-domain');
    el.setAttribute('href', 'mailto:' + addr);
    el.textContent = addr;
  });

  /* ---- Contact form spam traps ---- */
  document.querySelectorAll('.contact-form').forEach(function (form) {
    var ts = form.querySelector('[data-form-timestamp]');
    if (ts) ts.value = Date.now();

    form.addEventListener('submit', function (e) {
      var honeypot = form.querySelector('[name="contact[company_website]"]');
      var loadedAt = ts ? parseInt(ts.value, 10) : 0;
      var elapsed = loadedAt ? Date.now() - loadedAt : 99999;

      // 1. Honeypot filled -> bot
      if (honeypot && honeypot.value.trim() !== '') {
        e.preventDefault();
        return false;
      }
      // 2. Submitted implausibly fast (<3s) -> bot
      if (elapsed < 3000) {
        e.preventDefault();
        return false;
      }

      // Humans: strip the trap fields so they never reach the inbox
      if (honeypot) honeypot.removeAttribute('name');
      if (ts) ts.removeAttribute('name');
    });
  });

  /* ---- Mobile menu drawer ---- */
  const menu = document.querySelector('[data-menu-drawer]');
  const menuOverlay = document.querySelector('[data-menu-overlay]');
  const menuToggle = document.querySelector('[data-menu-toggle]');

  function openMenu() {
    if (!menu) return;
    menu.classList.add('is-open');
    menuOverlay && menuOverlay.classList.add('is-open');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    menuOverlay && menuOverlay.classList.remove('is-open');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  menuToggle && menuToggle.addEventListener('click', (e) => { e.preventDefault(); openMenu(); });
  document.querySelectorAll('[data-menu-close]').forEach((el) => el.addEventListener('click', closeMenu));
  menuOverlay && menuOverlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); });

  /* ---- Fetch + render cart ---- */
  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
    return res.json();
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  async function renderCart() {
    const body = drawer && drawer.querySelector('[data-cart-body]');
    const footer = drawer && drawer.querySelector('[data-cart-foot]');
    if (!body) return;
    const cart = await getCart();
    updateCartCount(cart.item_count);

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="text-muted">Your cart is empty.</p>';
      footer && (footer.innerHTML = '');
      return;
    }

    body.innerHTML = cart.items.map((item) => `
      <div class="cart-line" data-key="${item.key}">
        <div class="cart-line__img">${item.image ? `<img src="${item.image}" alt="">` : ''}</div>
        <div>
          <div style="font-weight:600;font-size:.9rem;">${item.product_title}</div>
          <div class="text-muted" style="font-size:.82rem;">Qty ${item.quantity}</div>
          <button class="btn btn--sm btn--outline" data-remove="${item.key}" style="margin-top:8px;padding:5px 12px;">Remove</button>
        </div>
        <div class="price">${money(item.final_line_price)}</div>
      </div>
    `).join('');

    footer && (footer.innerHTML = `
      <div style="display:flex;justify-content:space-between;margin-bottom:16px;">
        <span>Subtotal</span><strong>${money(cart.total_price)}</strong>
      </div>
      <a href="/checkout" class="btn btn--full">Check out</a>
      <a href="/cart" class="btn btn--outline btn--full" style="margin-top:10px;">View cart</a>
    `);

    body.querySelectorAll('[data-remove]').forEach((btn) =>
      btn.addEventListener('click', () => changeItem(btn.dataset.remove, 0))
    );
  }

  async function changeItem(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    renderCart();
  }

  /* ---- Add to cart (AJAX) ---- */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const original = btn && btn.textContent;
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 }),
        });
        openDrawer();
        await renderCart();
      } catch (err) {
        form.submit();
      } finally {
        if (btn) { btn.textContent = original; btn.disabled = false; }
      }
    });
  });

  /* ---- Init count on load ---- */
  getCart().then((c) => updateCartCount(c.item_count)).catch(() => {});
})();
